import { render, staticRenderFns } from "./JsonDataView.vue?vue&type=template&id=7bbea2b2&"
import script from "./JsonDataView.vue?vue&type=script&lang=js&"
export * from "./JsonDataView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports